// extracted by mini-css-extract-plugin
export default {"nullContent_container":"NullContent_nullContent_container__de5GP"};